/**
 * HTTP 和 BRIDGE 混合版
 * 端内优先桥接上报，端外走 http 上报
 */
import '../util/polyfill';
import type { HybridWeblogInitParams } from '@/types/configuration';
import Weblog from '@/platform/hybrid';
import { BasePlugin } from '../plugins/base';
import { addClass, initSilence } from '../util/namespace';
export type { SupportTypes, SendConfig, PVOptions, ShowOptions, TaskOptions, CustomOptions, BaseOptions } from './types';
export type WeblogInitParams = HybridWeblogInitParams;

export type LoggerConfigByUser = HybridWeblogInitParams[0];

// 注册到全局对象
addClass(Weblog);
initSilence();

export {
    Weblog,
    BasePlugin,
};

export default Weblog;
